var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, createContext } from 'react';
import { useForm } from '../context/FormContext';
import { createSetStepAction, createSetVehicleDetailsAction } from '../types/form/actions';
import { FindYourCar } from './steps/FindYourCar';
import { CustomerDetails } from './steps/CustomerDetails';
import { VehicleCondition } from './steps/VehicleCondition';
import { OnlineEstimation } from './steps/OnlineEstimation';
import { ApiClient } from '../api/apiClient';
import { getTranslation } from '../utils/i18n';
// Create a context for sub-screen tracking
export var SubScreenContext = createContext({
    currentSubScreen: '',
    setCurrentSubScreen: function () { }
});
// Track processed session IDs to prevent duplicate processing
window._tiofProcessedSessions = window._tiofProcessedSessions || new Set();
export var FormSteps = function (_a) {
    var _b;
    var formWrapperRef = _a.formWrapperRef, setDisablePreviousSteps = _a.setDisablePreviousSteps;
    var _c = useForm(), state = _c.state, dispatch = _c.dispatch;
    var _d = useState({}), formData = _d[0], setFormData = _d[1];
    var _e = useState(false), isRefreshing = _e[0], setIsRefreshing = _e[1];
    var _f = useState(null), errorMessage = _f[0], setErrorMessage = _f[1];
    var _g = useState(''), currentSubScreen = _g[0], setCurrentSubScreen = _g[1];
    // Scroll to top when step or sub-screen changes
    useEffect(function () {
        if (formWrapperRef && formWrapperRef.current) {
            // Always scroll window to the form, minus sticky nav
            var rect = formWrapperRef.current.getBoundingClientRect();
            var scrollTarget = window.scrollY + rect.top - 100;
            window.scrollTo({
                top: scrollTarget,
                behavior: 'smooth'
            });
        }
    }, [state.currentStep, currentSubScreen]);
    // Function to get saved data safely
    var getSavedData = function () {
        var _a;
        var savedData = ((_a = window === null || window === void 0 ? void 0 : window.tiofSettings) === null || _a === void 0 ? void 0 : _a.savedData) || {};
        // Convert API data format to FormState format
        var formattedData = __assign(__assign({}, savedData), { regoDetails: savedData.vehicle_rego ? {
                rego: savedData.vehicle_rego,
                state: savedData.vehicle_state || ''
            } : undefined, vehicleDetails: savedData.vehicle_details ? __assign(__assign({}, (typeof savedData.vehicle_details === 'string'
                ? JSON.parse(savedData.vehicle_details)
                : savedData.vehicle_details)), { entryMethod: savedData.entry_method || 'rego', registrationNumber: savedData.vehicle_rego || '', registrationState: savedData.vehicle_state || '', selectedOptions: [], selectedPacks: [] }) : null, currentStep: state.currentStep });
        return formattedData;
    };
    // Function to refresh form data (can be passed to child components)
    var refreshData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result, formattedData, error, error_1, errorMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsRefreshing(true);
                    setErrorMessage(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, ApiClient.refreshFormData()];
                case 2:
                    result = _a.sent();
                    if (result.success && result.data) {
                        // Update window.tiofSettings.savedData to keep it in sync
                        if (window.tiofSettings) {
                            window.tiofSettings.savedData = __assign({}, result.data);
                        }
                        formattedData = __assign(__assign({}, result.data), { regoDetails: result.data.vehicle_rego ? {
                                rego: result.data.vehicle_rego,
                                state: result.data.vehicle_state || ''
                            } : undefined, vehicleDetails: result.data.vehicle_details ? __assign(__assign({}, (typeof result.data.vehicle_details === 'string'
                                ? JSON.parse(result.data.vehicle_details)
                                : result.data.vehicle_details)), { entryMethod: result.data.entry_method || 'rego', registrationNumber: result.data.vehicle_rego || '', registrationState: result.data.vehicle_state || '', selectedOptions: [], selectedPacks: [] }) : null, currentStep: state.currentStep });
                        // Update the state with the formatted data
                        setFormData(formattedData);
                        return [2 /*return*/, formattedData];
                    }
                    else {
                        error = result.error || 'Failed to refresh data';
                        setErrorMessage(error);
                        // Fall back to window.tiofSettings.savedData
                        return [2 /*return*/, getSavedData()];
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    errorMsg = error_1 instanceof Error ? error_1.message : 'Unknown error refreshing form data';
                    setErrorMessage(getTranslation('formSteps.errors.refreshError', 'Failed to load your saved information. Please try again.'));
                    // Fall back to using window.tiofSettings.savedData on error
                    return [2 /*return*/, getSavedData()];
                case 4:
                    setIsRefreshing(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    // Initial data load only if we don't have data
    useEffect(function () {
        var _a;
        var savedData = (_a = window === null || window === void 0 ? void 0 : window.tiofSettings) === null || _a === void 0 ? void 0 : _a.savedData;
        if (!savedData || Object.keys(savedData).length === 0) {
            refreshData();
        }
    }, []);
    var handleNext = function () {
        dispatch(createSetStepAction(state.currentStep + 1));
    };
    var handleBack = function () { return __awaiter(void 0, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    // Refresh data when going back to ensure latest data is shown
                    return [4 /*yield*/, refreshData()];
                case 1:
                    // Refresh data when going back to ensure latest data is shown
                    _a.sent();
                    dispatch(createSetStepAction(Math.max(1, state.currentStep - 1)));
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    // Even if refresh fails, we should still allow navigation
                    dispatch(createSetStepAction(Math.max(1, state.currentStep - 1)));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    // --- Session restoration for ?finaliseoffer=... in the URL ---
    useEffect(function () {
        var fetchAndRestoreSession = function (sessionId_1, lastName_1, phone_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(void 0, __spreadArray([sessionId_1, lastName_1, phone_1], args_1, true), void 0, function (sessionId, lastName, phone, follow_up) {
                var result, sessionData, vehicleDetails, LAST_STEP, currentStep, nextStep, error_2;
                if (follow_up === void 0) { follow_up = false; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 3, , 4]);
                            return [4 /*yield*/, ApiClient.fetchPreviousSession(sessionId, lastName, phone, follow_up)];
                        case 1:
                            result = _a.sent();
                            if (!result.success) {
                                throw new Error(result.error || 'Invalid or expired session link. Please start a new request.');
                            }
                            if (!result.data) {
                                throw new Error('Failed to fetch previous session data');
                            }
                            sessionData = Array.isArray(result.data) ? result.data[0] : result.data;
                            // Update window.tiofSettings.savedData with the restored session data
                            if (window.tiofSettings) {
                                window.tiofSettings.savedData = sessionData;
                            }
                            // Set vehicle details in form context
                            if (sessionData.vehicle_details) {
                                vehicleDetails = void 0;
                                try {
                                    vehicleDetails = typeof sessionData.vehicle_details === 'string'
                                        ? JSON.parse(sessionData.vehicle_details)
                                        : sessionData.vehicle_details;
                                    dispatch(createSetVehicleDetailsAction(__assign({}, vehicleDetails)));
                                }
                                catch (err) {
                                    // Silently handle parsing errors
                                }
                            }
                            LAST_STEP = 4;
                            currentStep = Number(sessionData.tiof_step) || 1;
                            nextStep = void 0;
                            if (currentStep === 3) {
                                nextStep = 3; // Don't increment if current step is 3
                            }
                            else if (currentStep >= LAST_STEP) {
                                nextStep = LAST_STEP;
                            }
                            else {
                                nextStep = currentStep + 1;
                            }
                            // Force a small delay to ensure cookie data is set
                            return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 100); })];
                        case 2:
                            // Force a small delay to ensure cookie data is set
                            _a.sent();
                            dispatch(createSetStepAction(nextStep));
                            return [2 /*return*/, true];
                        case 3:
                            error_2 = _a.sent();
                            return [2 /*return*/, error_2 instanceof Error ? error_2.message : 'Something went wrong. Please try again later.'];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        var params = new URLSearchParams(window.location.search);
        var session_id = params.get('finaliseoffer');
        // Only run if session_id exists and hasn't been processed yet
        if (session_id && !window._tiofProcessedSessions.has(session_id)) {
            window._tiofProcessedSessions.add(session_id);
            (function () { return __awaiter(void 0, void 0, void 0, function () {
                var errorMsg;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, fetchAndRestoreSession(session_id, undefined, undefined, true)];
                        case 1:
                            errorMsg = _a.sent();
                            if (errorMsg !== true) {
                                setErrorMessage(errorMsg);
                            }
                            return [2 /*return*/];
                    }
                });
            }); })();
        }
    }, []);
    // Common props to pass to all step components
    var commonProps = {
        formData: ((_b = window.tiofSettings) === null || _b === void 0 ? void 0 : _b.savedData) || {}, // Use savedData directly
        refreshData: refreshData,
        isRefreshing: isRefreshing
    };
    // Render the current step component
    var renderCurrentStep = function () {
        switch (state.currentStep) {
            case 1:
                return _jsx(FindYourCar, __assign({}, commonProps, { onNext: handleNext }));
            case 2:
                return _jsx(CustomerDetails, __assign({}, commonProps, { onNext: handleNext, onBack: handleBack }));
            case 3:
                return _jsx(VehicleCondition, __assign({}, commonProps, { onNext: handleNext, onBack: handleBack }));
            case 4:
                return _jsx(OnlineEstimation, __assign({}, commonProps, { onNext: handleNext, onBack: handleBack, setDisablePreviousSteps: setDisablePreviousSteps }));
            default:
                return _jsx("div", { children: "Unknown step" });
        }
    };
    return (_jsx("div", { className: "tiof-form-inner", children: _jsxs(SubScreenContext.Provider, { value: { currentSubScreen: currentSubScreen, setCurrentSubScreen: setCurrentSubScreen }, children: [renderCurrentStep(), errorMessage && _jsx("div", { className: "error-message", role: "alert", children: errorMessage })] }) }));
};
